import { render, staticRenderFns } from "./ibox-list.vue?vue&type=template&id=eacb950a&"
import script from "./ibox-list.vue?vue&type=script&lang=js&"
export * from "./ibox-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploy/cp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eacb950a')) {
      api.createRecord('eacb950a', component.options)
    } else {
      api.reload('eacb950a', component.options)
    }
    module.hot.accept("./ibox-list.vue?vue&type=template&id=eacb950a&", function () {
      api.rerender('eacb950a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/packs/components/widgets/ibox-list.vue"
export default component.exports